import messageResource from '../../../../js/messageResource'
import {DateFormat} from '../../../../js/date_format'
import UserNameFormat from '../../../../js/util/UserNameFormat'
import {arrayToMap, isNotEmpty} from '../../../../js/atUtils'
import {downloadJsonAsCSV} from '../../../../js/csv/utils'
import {BalanceFormatter} from '../../../../js/util/BalanceFormatter'
import {BalanceHistory} from '../../../../js/balanceHistory/BalanceHistoryTable'
import LeaveTypeStore from '../../../../js/store/LeaveTypeStore'
import NumberFormatter from '../../../../js/number_formatter'

export default class CSVConverter {
    constructor() {
        this.dateFormatter = new DateFormat(window.SystemSettings.dateFormat)
        this.numberFormatter = new NumberFormatter(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 2, true)
        this.usersMap = arrayToMap(window.APReportsStore.getVisibleUsers())
    }

    convertAndSaveAsCSV({
        selectedUserId,
        balanceType,
        balanceModels,
        workHoursPerDay,
        spinner,
    }) {
        this.workHoursPerDay = workHoursPerDay
        this.balanceFormatter = new BalanceFormatter().init(workHoursPerDay, false)
        const json = {
            columnNames: this.getColumnNames(),
            columns: this.getColumns(),
            table: this.getRows(balanceType, balanceModels)
        }

        downloadJsonAsCSV([json], this.getFilename(balanceType, selectedUserId), () => spinner.stop())
    }

    getColumnNames() {
        return {
            effectiveDate: messageResource.getMessage('common.balance_history.table.date_cell.title'),
            description: messageResource.getMessage('common.description'),
            comment: messageResource.getMessage('common.Comment'),
            valueD: messageResource.getMessage('common.balance_history.csv_file.value', [messageResource.getMessage('common.balance_units.days.short')]),
            valueH: messageResource.getMessage('common.balance_history.csv_file.value', [messageResource.getMessage('common.balance_units.hours.short')]),
            endingBalanceD: messageResource.getMessage('common.balance_history.csv_file.ending_balance',
                [messageResource.getMessage('common.balance_units.days.short')]),
            endingBalanceH: messageResource.getMessage('common.balance_history.csv_file.ending_balance',
                [messageResource.getMessage('common.balance_units.hours.short')]),
        }
    }

    getColumns() {
        return ['effectiveDate', 'description', 'comment', 'valueD', 'valueH', 'endingBalanceD', 'endingBalanceH']
    }

    getRows(balanceType, balanceModels) {
        return balanceModels.map(balanceModel => {
            const rowModelParams = this.getRowModelParams(balanceModel, balanceType)
            return {
                effectiveDate: this.dateFormatter.formatDate(Date.parseJSONDate(balanceModel.effectiveDate)),
                description: rowModelParams.description,
                comment: rowModelParams.comment,
                valueD: rowModelParams.additionalSign + this.balanceFormatter.format(balanceModel.differenceValue),
                valueH: rowModelParams.additionalSign + this.balanceFormatter.format(balanceModel.differenceValue, true),
                endingBalanceD: this.numberFormatter.format(balanceModel.endingBalance),
                endingBalanceH: this.numberFormatter.format(this.recalculateFromDaysToHours(balanceModel.endingBalance)),
            }
        })
    }

    recalculateFromDaysToHours(days) {
        return days == null ? null : days * this.workHoursPerDay
    }

    getFilename(balanceType, selectedUserId) {
        const reportTypeText = messageResource.getMessage(balanceType === BalanceHistory.BalanceTypes.PTO
                                                          ? 'common.balance_history.table.pto'
                                                          : 'common.balance_history.table.sick')
        const user = this.usersMap[selectedUserId]
        return user.firstName + ' ' + user.lastName + ', ' +
               reportTypeText + ' Balance History (' +
               new DateFormat('MMM dd, yyyy').formatDate(window.currentUserTime()) + ').csv'
    }

    getRowModelParams(model) {
        switch (model.type) {
            case BalanceHistory.TableRows.AUTOMATIC_BALANCE_ACCRUE_RECORD:
                return {
                    description: messageResource.getMessage('common.balance_history.table.automatic_balance_accrue.label'),
                    comment: this.getColumnValue(model.comment),
                    additionalSign: '+',
                }
            case BalanceHistory.TableRows.AUTOMATIC_BALANCE_LIMIT_RECORD:
                return {
                    description: messageResource.getMessage('common.balance_history.table.automatic_balance_limit.label'),
                    comment: this.getColumnValue(model.comment),
                    additionalSign: '',
                }
            case BalanceHistory.TableRows.AUTOMATIC_BALANCE_RESET_RECORD:
                return {
                    description: messageResource.getMessage('common.balance_history.table.automatic_balance_reset.label'),
                    comment: this.getColumnValue(model.comment),
                    additionalSign: '',
                }
            case BalanceHistory.TableRows.LEAVE_TIME_COMPLETED_RECORD: {
                const leaveType = LeaveTypeStore.getLeaveType(model.leaveTypeId)
                return {
                    description: messageResource.getMessage('common.balance_history.table.leave_time_completed.label', [leaveType.name]),
                    comment: this.getColumnValue(model.comment),
                    additionalSign: '-',
                }
            }
            case BalanceHistory.TableRows.MANUAL_INCREASE_RECORD:
                return {
                    description: messageResource.getMessage('common.balance_history.table.manual_increase.label'),
                    comment: this.getManualAdjustmentComment(model.balanceManagerInfo, model.comment),
                    additionalSign: '+',
                }
            case BalanceHistory.TableRows.MANUAL_DECREASE_RECORD:
                return {
                    description: messageResource.getMessage('common.balance_history.table.manual_decrease.label'),
                    comment: this.getManualAdjustmentComment(model.balanceManagerInfo, model.comment),
                    additionalSign: '-',
                }
            case BalanceHistory.TableRows.MANUAL_SET_RECORD:
                return {
                    description: messageResource.getMessage('common.balance_history.table.manual_set.label'),
                    comment: this.getManualAdjustmentComment(model.balanceManagerInfo, model.comment),
                    additionalSign: '',
                }
        }
    }

    getManualAdjustmentComment(balanceManager, comment) {
        const balanceManagerInfo = messageResource.getMessage('common.balance_history.table.leave_time_completed.by.label',
            [UserNameFormat.formatFML(balanceManager.firstName, balanceManager.lastName, balanceManager.middleInitial)])
        const commentInfo = comment && isNotEmpty(comment) ? ' - ' + comment : ''
        return balanceManagerInfo + commentInfo
    }

    getColumnValue(comment) {
        return comment ? comment : ''
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/reports/balanceHistoryPage/CSVConverter.js